import React, {ComponentType} from 'react';

import type {ApplyDocumentShaperFuncType} from 'app/steps/document-shaper';

type RequiredEditProps = {
  onApplyDocumentShaper: ApplyDocumentShaperFuncType;
};

type InjectedProps = {
  elements: 'view' | 'edit' | void;
};
export function makeDiagramEditable<T>(
  DiagramEditableWrappedComponent: ComponentType<T>
): ComponentType<RequiredEditProps & T> {
  return function WrapperComponent(
    props: RequiredEditProps & T & InjectedProps
  ) {
    return <DiagramEditableWrappedComponent {...props} elements="edit" />;
  };
}
